import { ComputerStrategy } from './ComputerStrategy';
import ComputerStrategyAdvanced from './ComputerStrategyAdvanced';
import ComputerStrategyBasic from './ComputerStrategyBasic';

export default class ComputerStrategyFactory {

    public static create(type: string | undefined): ComputerStrategy {

        if(type === 'advanced-100') {
            return new ComputerStrategyAdvanced(
                {
                    slowingMovements: 0,
                    attackMovementPriorityThreshold: 60,
                    guardPriorityWeight: 60,
                    neutralTargetWeight: 100,
                    attackWinWeight: 15,
                    attackLoseWeight: 40,
                    attackComputerAccuracy: 500,
                    attackGuardUnits: 20,
                    slowingPrecisionReinforcements: 1
                }
            );
        }

        if(type === 'advanced-75') {
            return new ComputerStrategyAdvanced(
                {
                    slowingMovements: 0,
                    attackMovementPriorityThreshold: -40,
                    guardPriorityWeight: 80,
                    neutralTargetWeight: 60,
                    attackWinWeight: 10,
                    attackLoseWeight: 40,
                    attackComputerAccuracy: 100,
                    attackGuardUnits: 20,
                    slowingPrecisionReinforcements: 4
                }
            );
        }

        if(type === 'advanced-50') {
            return new ComputerStrategyAdvanced(
                {
                    slowingMovements: 0,
                    attackMovementPriorityThreshold: -200,
                    guardPriorityWeight: 100,
                    neutralTargetWeight: 40,
                    attackWinWeight: 10,
                    attackLoseWeight: 30,
                    attackComputerAccuracy: 40,
                    attackGuardUnits: 20,
                    slowingPrecisionReinforcements: 5
                }
            );
        }

        if(type === 'advanced-25') {
            return new ComputerStrategyAdvanced(
                {
                    slowingMovements: 0,
                    attackMovementPriorityThreshold: -300,
                    guardPriorityWeight: 50,
                    neutralTargetWeight: 20,
                    attackWinWeight: 10,
                    attackLoseWeight: 20,
                    attackComputerAccuracy: 20,
                    attackGuardUnits: 30,
                    slowingPrecisionReinforcements: 8
                }
            );
        }

        if(type === 'advanced-10') {
            return new ComputerStrategyAdvanced(
                {
                    slowingMovements: 1,
                    attackMovementPriorityThreshold: -300,
                    guardPriorityWeight: 0,
                    neutralTargetWeight: 0,
                    attackWinWeight: 10,
                    attackLoseWeight: 10,
                    attackComputerAccuracy: 0,
                    attackGuardUnits: 10,
                    slowingPrecisionReinforcements: 10
                }
            );
        }

        return new ComputerStrategyBasic();

    }
    
}